import { render, staticRenderFns } from "./AboutZZPR.vue?vue&type=template&id=cc4a8a92"
import script from "./AboutZZPR.vue?vue&type=script&lang=js"
export * from "./AboutZZPR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports